/**
 * Tab Reloader (page auto refresh)
 *
 * Declares exactly one web-accessible resource — data/counter/index.html — matched to
 * http(s) origins with no `use_dynamic_url`. That countdown page is fetchable at a fixed
 * URL from any page: it is served only when the extension is installed and the ID is fixed
 * in the URL, so the fetch is conclusive.
 *
 * There is no image or second WAR to corroborate with, so this is a single-signal module.
 *
 * Manifest verified against version 0.6.8.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dejobinhdiimklegodgbmbifijpppopn';

export const tabReloader: ExtensionDefinition = {
  id: ID,
  name: 'Tab Reloader (page auto refresh)',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Only one WAR — data/counter/index.html — exposed to every origin with no dynamic URL. ' +
    'A single fetch is conclusive.',
  signals: [
    {
      id: 'war-counter-index-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch data/counter/index.html — the countdown page, the sole web-accessible ' +
        'resource, served at a fixed URL only when installed.',
      weight: 1,
      run: () => probeFetch(ID, 'data/counter/index.html'),
    },
  ],
};
